const cardPatterns = [
	/^[A-Z]\d{7}$/, // Northwest Territories: N1234567
	/^\d{8}$/, // Prince Edward Island: 12345678
	/^\d{9}$/, // Nunavut: 123456789
	/^\d{5}-\d{4}$/, // Alberta: 12345-0000
	/^\d{3}-\d{3}-\d{3}$/, // Saskatchewan/Yukon/Manitoba: 123-456-789
	/^\d{3} \d{3} \d{3}$/, // New Brunswick: 123 456 789
	/^\d{4} \d{3} \d{3}$|^\d{10}$/, // Nova Scotia/British Columbia: 1234 567 890 or 1234567890
	/^\d{4}-\d{3}-\d{3}-[A-Z]{2}$|^\d{10}[A-Z]{2}$/, // Ontario: 1234-567-890-XX or 1234567890XX
	/^[A-Z]{4} \d{4} \d{4}$|^[A-Z]{4}\d{8}$/, // Quebec: XXXX 1234 5678 or XXXX12345678
	/^\d{3} \d{3} \d{3} \d{3}$|^\d{12}$/, // Newfoundland and Labrador: 123 456 789 001 or 123456789001
];

const SSN_PATTERN = /^\d{3}-\d{2}-\d{4}$/;

const VALID_PATTERNS = {
	CA: cardPatterns,
	US: [SSN_PATTERN],
};

const MAX_LENGTHS = {
	CA: 12,
	IN: 32,
};

export const getEntityCountryCode = resourceGroup => {
	const countryCodeMap = {
		'po-ca01': 'CA',
		'po-in01': 'IN',
	};

	return countryCodeMap[resourceGroup] || 'US';
};

export const isValidHealthCardNumber = (resourceGroup, cardNumber) => {
	const countryCode = getEntityCountryCode(resourceGroup);

	const maxLength = MAX_LENGTHS[countryCode];
	if (maxLength && cardNumber?.length > maxLength) {
		return { isValid: false, countryCode, errorType: 'maxCharLimit' };
	}

	const patterns = VALID_PATTERNS[countryCode] || [];
	const isValid = countryCode === 'IN' || patterns.some(pattern => pattern.test(cardNumber));

	return {
		isValid,
		countryCode,
		errorType: isValid ? '' : 'formatError',
	};
};

export const formatHealthCardNumber = (resourceGroup, cardNumber) => {
	if (!resourceGroup || !cardNumber) {
		return cardNumber;
	}
	const countryCode = getEntityCountryCode(resourceGroup);
	if (countryCode === 'CA') {
		return cardNumber.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
	}
	if (countryCode === 'US') {
		if (/^\d{9}$/.test(cardNumber)) {
			return `${cardNumber.slice(0, 3)}-${cardNumber.slice(3, 5)}-${cardNumber.slice(5)}`;
		}
	}
	return cardNumber;
};
